import { Article, DefaultArticleItemState, ListOptions } from "@tm/models"
import { useMemo } from "react"
import { usePartsViewOptions } from "@bundles/parts/components/ListV2/hooks"
import { useListOptionsContext } from "@bundles/parts/components/ListV2/ContextProvider"

export function useArticleOptions(article: Article): DefaultArticleItemState["options"] {
    const options = useListOptionsContext()

    const {
        partsViewSettings: { compactView, quantitySuggestionEnabled },
    } = usePartsViewOptions()
    const hasSuggestedQuantity = quantitySuggestionEnabled && !!article.suggestedQuantity

    const expanded = useMemo(() => {
        if (options.tileView) {
            return options.expandedArticleIds?.[article.id] ?? false
        }

        return options.expandedArticleIds?.[article.id] ? compactView : !compactView
    }, [article.id, compactView, options.expandedArticleIds, options.tileView])

    return useMemo(
        () => mergeOptions(options, { compactView, hasSuggestedQuantity, expanded }),
        [options, compactView, hasSuggestedQuantity, expanded]
    )
}

// TODO add here more disable cases
function mergeOptions(options: ListOptions, other: Partial<DefaultArticleItemState["options"]>): DefaultArticleItemState["options"] {
    return {
        ...options,
        ...other,
        hideCostEstimationButton: options.hideCostEstimationButton,
        hideAddToBasketButton: options.hideAddToBasketButton,
    }
}
